/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCircleNumber1 = createReactComponent("circle-number-1", "IconCircleNumber1", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M10 10l2 -2v8", key: "svg-1" }]
]);

export { IconCircleNumber1 as default };
//# sourceMappingURL=IconCircleNumber1.js.map
